import React from "react";
import DeviceMapManager from "../../components/attendance/DeviceMapManager";

export default function StaffDeviceMapPage() {
  return <DeviceMapManager subjectType="STAFF" title="Staff Device ID Mapping" personLabel="Staff" />;
}
